<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Co-funding Access Agreement" />
    </template>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tempus ligula nec nulla iaculis ornare sit amet in nunc.
      Nullam quis nibh nec diam maximus facilisis. Praesent ac nisi vel lectus sollicitudin dapibus ut eu nibh.
      Curabitur tincidunt nisl quis pharetra scelerisque. In maximus aliquam venenatis. Ut turpis magna, semper et aliquet quis, posuere id felis.
      Nam rutrum sit amet purus at gravida. Duis pharetra venenatis nulla non tincidunt. Vestibulum placerat libero et sapien vehicula interdum.
      Vivamus malesuada purus orci, a ullamcorper leo maximus sed. In id molestie odio. Integer viverra ut justo eu suscipit.
    </p>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tempus ligula nec nulla iaculis ornare sit amet in nunc.
      Nullam quis nibh nec diam maximus facilisis. Praesent ac nisi vel lectus sollicitudin dapibus ut eu nibh.
      Curabitur tincidunt nisl quis pharetra scelerisque. In maximus aliquam venenatis. Ut turpis magna, semper et aliquet quis, posuere id felis.
      Nam rutrum sit amet purus at gravida. Duis pharetra venenatis nulla non tincidunt. Vestibulum placerat libero et sapien vehicula interdum.
      Vivamus malesuada purus orci, a ullamcorper leo maximus sed. In id molestie odio. Integer viverra ut justo eu suscipit.
    </p>
    <div class="text-center">
      <signature-writer @clear="signature = null" @end="signatureDrawn" />
      <template v-if="signature">
        <figure class="figure mt-3">
          <img v-if="signature" class="bg-light" :src="signature">
          <figcaption>{{ $auth.user.profile.firstName }} {{ $auth.user.profile.lastName }}'s signature</figcaption>
        </figure>
        <div class="mt-3">
          <base-button secondary @click="generate">Sign &amp; Submit</base-button>
        </div>
      </template>
    </div>
  </base-content>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'
import SignatureWriter from '@/components/SignatureWriter.vue'

export default {
  components: {
    HeroHeader,
    SignatureWriter
  },

  data: () => ({
    signature: null
  }),

  methods: {
    generate () {
      this.$store.dispatch('core/documents/generate-co-funding', {
        signature: this.signature
      })
    },

    signatureDrawn (url) {
      this.signature = url
    }
  }
}
</script>
